import { render, staticRenderFns } from "./ModalStatistiche.vue?vue&type=template&id=3eb1ac54&scoped=true&lang=pug&"
import script from "./ModalStatistiche.vue?vue&type=script&lang=ts&"
export * from "./ModalStatistiche.vue?vue&type=script&lang=ts&"
import style0 from "./ModalStatistiche.vue?vue&type=style&index=0&id=3eb1ac54&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb1ac54",
  null
  
)

export default component.exports